import { DATA_GIF_PATH } from "@/app/utils/config";

const InitialPage = () => {
  return (
    <div className="flex h-screen w-screen items-center justify-center overflow-x-hidden bg-center">
      <div className="flex flex-col items-center text-2xl text-white">
        <img
          src={`${DATA_GIF_PATH}mainlogo.gif`}
          alt="Growx loading page"
          aria-label="Growx loading page"
          width={400}
          height={400}
          loading="eager"
          decoding="async"
        />
      </div>
    </div>
  );
};

export default InitialPage;